// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
export const getIMAReachModalStyles = ({ entityItem = {} }, { palette = {} }) => ({
  imaReachModal: {
    '& .ms-Dialog-title': {
      fontWeight: '600 !important',
      fontSize: '20px',
      lineHeight: '27px',
    },
  },
});
